module.exports = "//public.getcloudapp.com/packs/media/images/icons-edit-minimal-67c647079c080e4c7c8522fbe314faa4.svg";